export default "__VITE_ASSET__CjbztKve__"